export const TOKEN_TYPE = "token_type";
export const AUTH_TOKEN = "access_token";
export const LOGIN_USER_ID = "userId";
export const LOGIN_TYPE = "loginType";
export const LOGIN_FIRST_TIME = "isLoginFirst";
export const IDENTIFIER = "identifier";

export const MY_LANGUAGE_ID = 4;
export const EN_LANGUAGE_ID = 1;

export const LOGIN_TYPE_OPTIONS = [
  { value: "3", label: "Group Identifier" },
  { value: "4", label: "Identifier & password" },
  { value: "5", label: "Social Login - Firebase" },
];

export const PEOPLE_PREFIX = [
  { value: "Mr", label: "Mr." },
  { value: "Mrs", label: "Mrs." },
  { value: "Ms", label: "Ms." },
  { value: "Miss", label: "Miss" },
  { value: "MSTR", label: "MSTR." },
  // { value: "INF", label: "INF." },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  // { value: "Child", label: "Child" },
  // { value: "Infant", label: "Infant" }
];

export const COMPANY_PEOPLE_PREFIX = [
  { value: "Mr.", label: "Mr." },
  { value: "Mrs.", label: "Mrs." },
  { value: "Ms.", label: "Ms." },
  { value: "Miss.", label: "Miss." },
  { value: "MSTR", label: "MSTR" },
  { value: "Male", label: "Male" },
  { value: "Female", label: "Female" },
  { value: "INF", label: "INF" },
  { value: "Child", label: "Child" },
  { value: "Infant", label: "Infant" },
];

// Local storage key for "Sync" and "Export" button disable time.
export const SYNC_EXPORT_BTN_DISABLE = "SyncExportBtnDisable";
export const SYNC_DOWNLOAD_BTN_DISABLE = "SyncDownloadBtnDisable";

export const FINANCE_MATCHING_PAGE = "finance-matching";
export const PERMISSION_V3 = [
  { id: "1", type: "menu", name: "Home/Search" },
  { id: "2", type: "submenu", name: "Top Menu" },
  { id: "3", type: "field", name: "Flights" },
  { id: "4", type: "field", name: "Hotels" },
  { id: "5", type: "field", name: "Hotels (Offline)" },
  { id: "6", type: "field", name: "Hotels (Online)" },
  { id: "7", type: "field", name: "Buses" },
  { id: "8", type: "field", name: "Car Rentals" },
  { id: "9", type: "field", name: "Balloons" },
  { id: "10", type: "field", name: "Promotions" },
  { id: "11", type: "field", name: "Blog" },
  { id: "12", type: "field", name: "Login" },
  { id: "13", type: "field", name: "Promotion Slider" },
  { id: "14", type: "menu", name: "Select" },
  { id: "15", type: "submenu", name: "Pricing" },
  { id: "16", type: "field", name: "Selling price" },
  { id: "17", type: "field", name: "Original rate" },
  { id: "18", type: "field", name: "Flight details" },
  { id: "19", type: "field", name: "Fare packages" },
  { id: "20", type: "field", name: "Fare breakdown selling price" },
  { id: "21", type: "field", name: "$GB" },
  { id: "22", type: "field", name: "$NB" },
  { id: "23", type: "field", name: "$TF" },
  { id: "24", type: "field", name: "$SF" },
  { id: "25", type: "field", name: "Fare breakdown showfare" },
  { id: "26", type: "field", name: "$GB" },
  { id: "27", type: "field", name: "$TF" },
  { id: "28", type: "menu", name: "Customer Details" },
  { id: "29", type: "submenu", name: "Contact Details" },
  { id: "30", type: "field", name: "Title" },
  { id: "31", type: "field", name: "First Name + Middle Name" },
  { id: "32", type: "field", name: "Last Name" },
  { id: "33", type: "field", name: "Mobile Number" },
  { id: "34", type: "field", name: "Email" },
  { id: "35", type: "field", name: "Company name (Optional)" },
  { id: "36", type: "submenu", name: "Traveller" },
  { id: "37", type: "field", name: "Same as contact info" },
  { id: "38", type: "field", name: "Title" },
  { id: "39", type: "field", name: "First Name + Middle Name" },
  { id: "40", type: "field", name: "Last Name" },
  { id: "41", type: "field", name: "Mobile Number" },
  { id: "42", type: "field", name: "Email" },
  { id: "43", type: "field", name: "Date of Birth" },
  { id: "44", type: "field", name: "NRC" },
  { id: "45", type: "field", name: "Country of Passport/ID" },
  { id: "46", type: "field", name: "Region" },
  { id: "47", type: "field", name: "Township" },
  { id: "48", type: "field", name: "Address" },
  { id: "49", type: "field", name: "Save details for later" },
  { id: "50", type: "menu", name: "Payment" },
  { id: "51", type: "submenu", name: "Gateways" },
  { id: "52", type: "field", name: "KBZPay" },
  { id: "53", type: "field", name: "Credit/Debit Card" },
  { id: "54", type: "field", name: "KBZ Quick Pay" },
  { id: "55", type: "field", name: "Aya Bill Payments" },
  { id: "56", type: "field", name: "Wave Bill Payments" },
  { id: "57", type: "field", name: "Cash on Delivery" },
  { id: "58", type: "field", name: "Bank Transfer / Mobile Banking" },
  { id: "59", type: "field", name: "Wave Pay" },
  { id: "60", type: "field", name: "MPU Payment" },
  { id: "61", type: "field", name: "123 OTC Payments" },
  { id: "62", type: "field", name: "Paypal" },
  { id: "63", type: "field", name: "M-Pitesan" },
  { id: "64", type: "field", name: "OnePay" },
  { id: "65", type: "field", name: "Citizens Pay" },
  { id: "66", type: "field", name: "Visa/Master Payments" },
  { id: "67", type: "field", name: "MPT Fast Pay" },
  { id: "68", type: "field", name: "AYA Pay" },
  { id: "69", type: "field", name: "Balance" },
  { id: "70", type: "field", name: "Promo code" },
];

export const PERMISSION_CLASSES = [
  { value: "Guest", label: "Guest" },
  { value: "B2C", label: "B2C" },
  { value: "B", label: "B" },
  { value: "C", label: "C" },
  { value: "N", label: "N" },
];

export const ALLOW_IDENTIFIER = [
  "arkar.oo@flymya.co",
  "moe.myint.aung@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "may.myat.mon@flymya.co",
  "kyaw.kyaw.htet@flymya.co",
  "wai.wai.lwin@flymya.co",
  "oakkar.phyo@flymya.co",
  "min.sett.paing@flymya.co",
  "ni.ni.win@flymya.co",
  "win.ei.ei.khaing@flymya.co",
  "wai.wai.hlaing@flymya.co",
  "kaung.myat.kyaw@flymya.co",
  "theint.myat.sandy@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "tim.duits@flymya.co",
  "ei.myat.myat.thwe@flymya.co",
  "ei.kay.khine@flymya.co",
  "nyein.su.htike@flymya.co",
  "htut.paing.soe@flymya.co",
];
export const ALLOW_AIRPORT_IDENTIFIER = [
  "moe.myint.aung@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "may.myat.mon@flymya.co",
  "kyaw.kyaw.htet@flymya.co",
  "wai.wai.lwin@flymya.co",
  "oakkar.phyo@flymya.co",
  "min.sett.paing@flymya.co",
  "ni.ni.win@flymya.co",
  "win.ei.ei.khaing@flymya.co",
  "wai.wai.hlaing@flymya.co",
  "kaung.myat.kyaw@flymya.co",
  "theint.myat.sandy@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "hsu.shwe.sin.oo@flymya.co",
  "htut.paing.soe@flymya.co",
  "nyein.chaw.thu@flymya.co",
  "lin.yadanar.naing@flymya.co",
  "ei.myat.yadanar@flymya.co",
  "thin.thin.aye@flymya.co",
  "min.htet.soe@flymya.co",
];

// for offline products
export const ALLOW_OFFLINE_IDENTIFIER = [
  "kaung.myat.kyaw@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "moe.myint.aung@flymya.co",
  "may.myat.mon@flymya.co",
  "kyaw.kyaw.htet@flymya.co",
  "thaw.zin.lin@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "ei.kay.khine@flymya.co",
];

export const ALLOW_OFFLINE_FLIGHT_IDENTIFIER = [
  "kaung.myat.kyaw@flymya.co",
  "wai.wai.hlaing@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "may.myat.mon@flymya.co",
  "kyaw.kyaw.htet@flymya.co",
];

export const ALLOW_OFFLINE_BUS_IDENTIFIER = [
  "kaung.myat.kyaw@flymya.co",
  "wai.wai.hlaing@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "may.myat.mon@flymya.co",
  "kyaw.kyaw.htet@flymya.co",
];

export const ALLOW_HR_IDENTIFIER = [
  "myat.thu.thu.htoon@flymya.co",
  "moe.myint.aung@flymya.co",
  "naw.khuu.khu.gay@flymya.co",
  "aye.myat.thandar@flymya.co",
  "kyaw.kyaw.htet@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "may.myat.mon@flymya.co",
];

export const ALLOW_VALID_DATE_IDENTIFIER = [
  "moe.myint.aung@flymya.co",
  "khin.cho.myint@flymya.co",
  "phyu.thinn.aung@flymya.co",
];

export const BUS_CLASS_TYPE_OPTIONS = [
  { value: "Standard", label: "Standard" },
  { value: "Business", label: "Business" },
  { value: "VIP", label: "VIP" },
];

export const AUTOMATED_MESSAGE_TYPE = [
  { value: "Welcome message", label: "Welcome message" },
  { value: "Discount message", label: "Discount message" },
  { value: "Closed message", label: "Closed message" },
  { value: "Campaign message", label: "Campaign message" },
];

export const AUTOMATED_CHANNEL = [
  { value: "Experience Myanmar Bot", label: "Experience Myanmar Bot" },
  { value: "Flymya Bot", label: "Flymya Bot" },
  { value: "Dash Bot", label: "Dash Bot" },
];

export const ALLOW_SHORTLINK_AND_QR = [
  "moe.myint.aung@flymya.co",
  "tim.duits@flymya.co",
];

export const ALLOW_FEEDBACK = [
  "moe.myint.aung@flymya.co",
  "thaw.zin.lin@flymya.co",
];

export const ALLOW_CRAWLED_ROUTES = [
  "kaung.myat.kyaw@flymya.co",
  "moe.myint.aung@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "theint.myat.sandy@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "thaw.zin.lin@flymya.co",
];

export const ALLOW_ARRANGER_MERGE = [
  "moe.myint.aung@flymya.co",
  "kyaw.thu@flymya.co",
];

export const ALLOW_ARRANGER_POINTS = [
  "moe.myint.aung@flymya.co",
  "hla.cho.htut@flymya.co",
  "may.thu.cho@flymya.co",
  "ei.myat.myat.thwe@flymya.co",
  "may.myat.mon@flymya.co",
  "aye.chan.maung@flymya.co",
  "phoo.thet.ngon@flymya.co",
];

export const ALLOW_HANDOVER = [
  "moe.myint.aung@flymya.co",
  "wai.wai.lwin@flymya.co",
  "min.sett.paing@flymya.co",
  "oakkar.phyo@flymya.co",
  "wai.wai.hlaing@flymya.co",
  "ni.ni.win@flymya.co",
  "win.ei.ei.khaing@flymya.co",
  "min.htet.soe@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "shwe.sin.oo@flymya.co",
  "nyein.chaw.thu@flymya.co",
  "lin.yadanar.naing@flymya.co",
  "ei.myat.yadanar@flymya.co",
  "thin.thin.aye@flymya.co",
  "hsu.shwe.sin.oo@flymya.co",
  "ei.phyu.kyaw@flymya.co",
  "kyaw.thura@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "hnin.htet.wai.aung@flymya.co",
];

export const ALLOW_OFFLINE_PRODUCT_TYPE = [
  "kaung.myat.kyaw@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "may.myat.mon@flymya.co",
  "moe.myint.aung@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "thaw.zin.lin@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "theint.myat.sandy@flymya.co",
];

export const CCM_STATUS_OPTIONS = [
  { value: 1, label: "Lead" },
  { value: 2, label: "Prospect" },
  { value: 3, label: "Opportunity" },
  { value: 4, label: "Followed up" },
  { value: 5, label: "Sales Close/ Sales Won" },
  { value: 6, label: "Sales Lost" },
];

export const ALLOW_AIRLINE_UPDATE_IDENTIFIER = [
  "moe.myint.aung@flymya.co",
  "kaung.myat.kyaw@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "theint.myat.sandy@flymya.co",
];

export const ALLOW_PAYMENT_UPDATE_IDENTIFIER = [
  "moe.myint.aung@flymya.co",
  "kaung.myat.kyaw@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "may.myat.mon@flymya.co",
];

export const ALLOW_VIBER_MSG_IDENTIFIER = [
  "moe.myint.aung@flymya.co",
  "kaung.myat.kyaw@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "ei.myat.myat.thwe@flymya.co",
  "may.thu.cho@flymya.co",
];

export const ALLOW_PRODUCT_UUID_IDENTIFIER = [
  "kyaw.kyaw.htet@flymya.co",
  "kyaw.thu@flymya.co",
  "hla.cho.htut@flymya.co",
  "khin.lapyae.win@flymya.co",
  "moe.myint.aung@flymya.co",
  "arkar.oo@flymya.co",
  "phyu.thinn.aung@flymya.co",
  "myat.thu.thu.htoon@flymya.co",
  "may.myat.mon@flymya.co",
  "thet.su.su.kyaw@flymya.co",
  "hsu.shwe.sin.oo@flymya.co",
];

export const RELATIONSHIP_OPTIONS = [
  { value: "Children", label: "Children" },
  { value: "Grandchildren", label: "Grandchildren" },
  { value: "Parents", label: "Parents" },
  { value: "Siblings", label: "Siblings" },
  { value: "Spouse", label: "Spouse" },
  { value: "Other", label: "Other" },
];

export const ADDITIONAL_COVER_OPTIONS = [
  {
    value: "additional_infectious_diseases",
    label: "Additional Infectious Diseases",
  },
  { value: "trip_cancellation", label: "Trip Cancellation" },
  { value: "baggage_delay", label: "Baggage Delay" },
  { value: "personal_liability", label: "Personal Liability" },
  { value: "baggage_loss_n_damage", label: "Baggage Loss and Damage" },
  { value: "flight_delay", label: "Flight Delay" },
];
